import { constants, IDataGridColumnConfiguration } from '@trackman/baseball-shared-components';
import { DataKey } from 'enums/DataKey';
import { IReviewPlayer, IReviewPlayerExtended } from 'interfaces/review/IReviewPlayer';
import { ReviewDataRow } from 'models/review/ReviewDataRow/ReviewDataRow';

export const getErrorMessageForEmptyValues = (columnName: string): string | undefined => `No ${columnName}`;

export const isSimpleCellEmpty = (value: string) => {
  if (value === '' || value === null || value === undefined || value === constants.undefinedValue) {
    return true;
  }
  return false;
};

export const isPlayerCellEmpty = (player: IReviewPlayer) => {
  if (player.name === '' || player.name === null || player.name === undefined) {
    return true;
  }
  return false;
};

export const getPlayerFromColumn = (row: ReviewDataRow, column: IDataGridColumnConfiguration): IReviewPlayerExtended => {
  const key = column.dataKey as keyof ReviewDataRow;
  const player = row[key] as IReviewPlayerExtended;
  return { ...player, defaultPosition: column.dataKey as DataKey } as IReviewPlayerExtended;
};
